import { PageActions } from "../../../../components/implementer/submissions"

export const editData = ({ save, currentStepKey, stepsToOmit }) => {
  return {
    stepsToOmit,
    currentStepKey,
    title: "Modificar solicitud",
    actions: <PageActions save={save} />
  }
}
